import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import { ButtonContained } from '../components/app-button/button'
import SiteBox from '../components/site-box'
import CustomizeAll from '../components/сustomize-all/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    width: 631,
    marginTop: 54,
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class AddGa extends Component {
  state = {
    activeStep: 2,
    site: window.state.site,
    error: window.state.error,
  }

  render() {
    const { classes } = this.props
    const { site } = this.state
    const steps = getSteps()

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />

          <AppStepper activeStep={this.state.activeStep} steps={steps} />

          <div className={classes.wizardContent}>
            <SiteBox
              url={site.url}
              resource={site.name}
              gutterBottom={24}
              prevUrl={'/wizard/site'}
            />

            <div style={{ maxWidth: 340, marginLeft: 66 }}>
              <Typography
                variant="body1"
                style={{
                  marginBottom: 25,
                  fontFamily: 'Caveat, cursive',
                  letterSpacing: 1.1,
                  color: 'rgba(0, 0, 0, 0.6)',
                  maxWidth: 300,
                }}
              >
                Подключение аккаунта Google Analytics, в который ROMI center будет передавать данные о ваших расходах из рекламных сервисов, продаж из CRM системы и звонков из коллтрекинга.
              </Typography>

              {this.state.error ? (
                <div
                  style={{
                    color: 'red',
                    marginBottom: '30px',
                  }}
                >
                  {this.state.error}
                </div>
              ) : null}

              <a href="/wizard/ga/auth" className={classes.link}>
                <ButtonContained
                  style={{
                    fontSize: 16,
                    width: '100%',
                    padding: '12px 0',
                    fontWeight: 700,
                    color: '#fff',
                  }}
                  type="submit"
                  color="secondary"
                  text="Подключить Google Analytics"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(AddGa)
